import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {SYSTEM_NAME} from 'src/app/shared/constants/constants';

@Component({
  selector: 'app-reset-password-email',
  templateUrl: './reset-password-email.component.html',
  styleUrls: ['./reset-password-email.component.scss']
})
export class ResetPasswordEmailComponent implements OnInit {
  currentYear: any;
  loading = false;
  loginView = false;
  subscription: Subscription = new Subscription();
  resetPasswordForm: FormGroup;
  userType: string;
  title: string;
  isLogin = true;
  showPassword: boolean;
  redirectUrl: string;
  sessionExpired: boolean;
  systemPhone;
  message = "Welcome again to";


  constructor(
    private fb: FormBuilder,
    private route: Router,
    // // private store: Store<AppState>,
    // private apollo: Apollo,
    // private authService: AuthService,
    // private storage: StorageService,
    // private notificationService: NotificationService,
    // private location: Location,
    // private router: Router
  ) {
    // this.redirectUrl = this.storage.getItem('redirectUrl');
    // this.sessionExpired = this.storage.getItem('sessionExpired');
  }

  ngOnInit(): void {
    //
    // if (this.router.url.includes('logout')) {
    //   // this.authService.logout();
    // }
    //
    // if (this.sessionExpired) {
    //   this.storage.removeItem('sessionExpired');
    // }
    //
    this.title = SYSTEM_NAME;
    //
    // this.currentYear = new Date().getFullYear();
    this.resetPasswordForm = this.fb.group({
      email: [null],
    });
    // this.forgotPasswordForm = this.fb.group({
    //   email: [null, [Validators.required, Validators.email]],
    // });
  }
  //
  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
  //
  async login() {
  //   // await this.authService.login(auth);
  //   // await this.authService.authRole();
  //
  //   this.userType = this.storage.getItem('userType');
  //   let photo;
  //
  //   const redirectTo = localStorage.getItem('urlToRedirect');
  //   if (redirectTo) {
  //     localStorage.removeItem('urlToRedirect');
  //     return this.route.navigateByUrl(redirectTo);
  //   }
  //
    return  this.route.navigateByUrl('/tgsd-landing');
  //
  }
  //
  // changeView() {
  //   this.loginView = !this.loginView;
  // }
  //
  // goBack() {
  //   this.location.back();
  // }
  //
  // goToUrl(slug) {
  //   this.route.navigateByUrl(slug);
  // }
  //
  forgetPassword(formValue: any) {
    // this.store.dispatch(sendPasswordResetEmail({email: formValue?.email}));
  }

  toggleLogin() {
    this.isLogin = !this.isLogin;
  }
  //
  // ngOnDestroy(): void {
  //   this.subscription.unsubscribe();
  // }
  // resetPasswordForm: FormGroup;
  // currentYear;
  // title: string;
  // reset: boolean;
  // token: string;
  // subscriptions = new Subscription();
  // showPassword = false;

  // constructor(
  //   private fb: FormBuilder,
  //   private apollo: Apollo,
  //   private notificationService: NotificationService,
  //   private responseCodesService: ResponseCodeService,
  //   private authService: AuthService,
  //   private storageService: StorageService,
  //   private router: Router,
  //   private store: Store<AppState>,
  //   private activatedRoute: ActivatedRoute,
  // ) {
  // }

  // ngOnDestroy(): void {
  //   this.subscriptions.unsubscribe();
  // }

  // togglePasswordVisibility() {
  //   this.showPassword = !this.showPassword;
  // }

  // ngOnInit(): void {
  //   this.currentYear = new Date().getFullYear();

  //   this.subscriptions.add(this.activatedRoute.queryParams.subscribe(params => {
  //     if (params.hasOwnProperty('token')) {
  //       this.token = params.token;
  //       console.log("***token***:", this.token);
  //     }
  //   }));

  //   if (this.router.url.indexOf("c") === 1) {
  //     this.title = "Create Password";
  //     this.reset = false;
  //     this.resetPasswordForm = this.fb.group({
  //       newPassword: [
  //         null,
  //         [
  //           Validators.required,
  //           Validators.minLength(8),
  //           Validators.pattern('^(?=.*[A-Z]).{8,}$'),
  //           Validators.pattern('^(?=.*[!@#$&*]).{8,}$'),
  //           Validators.pattern('^(?=.*[0-9]).{8,}$'),
  //         ],
  //       ],
  //       confirmPassword: [null, Validators.required],
  //     });
  //   } else if (this.router.url.indexOf("reset-password") === 1) {
  //     this.title = "Reset Password";
  //     this.reset = true;

  //     this.resetPasswordForm = this.fb.group({
  //       oldPassword: [null],
  //       newPassword: [
  //         null,
  //         [
  //           Validators.required,
  //           Validators.minLength(8),
  //           Validators.pattern('^(?=.*[A-Z]).{8,}$'),
  //           Validators.pattern('^(?=.*[!@#$&*]).{8,}$'),
  //           Validators.pattern('^(?=.*[0-9]).{8,}$'),
  //         ],
  //       ],
  //       confirmPassword: [null, Validators.required],
  //     });
  //   }
  // }


  // resetPassword(formValues) {
  //   if (formValues.newPassword !== formValues.confirmPassword) {
  //     return this.notificationService.errorMessage("The Confirm password does not match");
  //   }
  //   //
  //   // const response = await this.authService.clientTokenRequest();
  //   //
  //   if (!this.reset) return this.createPassword(formValues);
  //   this.store.dispatch(passwordChange({
  //     oldPassword: formValues?.oldPassword,
  //     newPassword1: formValues?.newPassword,
  //     newPassword2: formValues?.confirmPassword,
  //   }));
  // }


  // createPassword(formValues) {
  //   this.store.dispatch(passwordReset({
  //     newPassword1: formValues?.newPassword,
  //     newPassword2: formValues?.confirmPassword,
  //     token: this.token
  //   }))
  // }

}
